import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

@Injectable()
export class V3RedirectGuard implements CanActivate {
  canActivate(): boolean {
    window.location.href = 'https://dxp.iti-digital.com';
    return false;
  }
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/guards/redirect.to.v3.guard.ts